import React from 'react';
import classNames from 'classnames';
import Item from '../Item/Item';

export default function Filters({ filters, customState }) {
  return (
    <div
      className={classNames('my-gift__filters', `my-gift__filters_${customState}`, {
        'my-gift__filters_odd': filters?.length % 2,
        'my-gift__filters_full': filters?.length < 2,
      })}
    >
      {filters.map((el, id) => (
        <Item key={id} customState={customState} index={id} {...el} />
      ))}
    </div>
  );
}
